/* Ecotex Digital - Elegir obligatoriamente 'Necesito factura' / 'No necesito factura' en carrito y carrito lateral.
   Versión compacta: pregunta y botones Sí / No en una fila. Si elige Sí: NIF/CIF validado y razón social obligatorios.
   Se carga desde snippets/cart-shipping-bar.liquid. Guarda los datos como atributos del pedido:
   'Necesita factura' (Sí / No), 'NIF/CIF' y 'Razón social'. */
(function () {
  if (window.etFacInit) return;
  window.etFacInit = true;

  var KEY_ON = 'Necesita factura';
  var KEY_NIF = 'NIF/CIF';
  var KEY_RS = 'Razón social';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var LETRAS = 'TRWAGMYFPDXBNJZSQVHLCKE';
  var MSG_ELIGE = 'Indica si necesitas factura para continuar';
  var MSG_NIF_VACIO = 'Introduce tu NIF o CIF';
  var MSG_NIF_MAL = 'Este NIF/CIF no es válido. Revisa los números y la letra';
  var MSG_RS_VACIO = 'Introduce la razón social o tu nombre completo';
  var st = { choice: '', nif: '', rs: '' };
  var uid = 0;

  function norm(v) {
    v = String(v || '').toUpperCase().replace(/[^0-9A-Z]/g, '');
    if (/^ES[0-9A-Z]{9}$/.test(v)) v = v.slice(2);
    return v;
  }

  function valid(v) {
    if (/^[0-9]{8}[A-Z]$/.test(v)) return LETRAS.charAt(parseInt(v.slice(0, 8), 10) % 23) === v.charAt(8);
    if (/^[XYZ][0-9]{7}[A-Z]$/.test(v)) return LETRAS.charAt(parseInt('XYZ'.indexOf(v.charAt(0)) + v.slice(1, 8), 10) % 23) === v.charAt(8);
    if (/^[ABCDEFGHJNPQRSUVW][0-9]{7}[0-9A-J]$/.test(v)) {
      var s = 0;
      for (var i = 0; i < 7; i++) {
        var d = parseInt(v.charAt(i + 1), 10);
        if (i % 2 === 0) { d = d * 2; d = Math.floor(d / 10) + (d % 10); }
        s += d;
      }
      var c = (10 - (s % 10)) % 10;
      return v.charAt(8) === String(c) || v.charAt(8) === 'JABCDEFGHI'.charAt(c);
    }
    return false;
  }

  function addCss() {
    if (document.getElementById('et-fac-css')) return;
    var css = [
      '.et-fac{margin:0 0 12px;text-align:left;}',
      '.et-fac__head{display:flex;align-items:center;justify-content:space-between;gap:8px 12px;flex-wrap:wrap;}',
      '.et-fac__q{font-size:14px;font-weight:600;color:#0C3B33;margin:0;line-height:1.3;}',
      '.et-fac__opts{display:flex;gap:6px;}',
      '.et-fac__opt{position:relative;display:inline-flex;gap:7px;align-items:center;border:none;border-radius:999px;padding:7px 14px 7px 10px;cursor:pointer;background:#f5faf8;margin:0;transition:background-color .2s,box-shadow .2s;}',
      '.et-fac__opt:hover{background:#ebf6f1;}',
      '.et-fac__opt.is-checked{background:#e1f5ee;}',
      '.et-fac.is-error .et-fac__opt{background:#fdf3f3;box-shadow:inset 0 0 0 1px #d93c3c;}',
      '.et-fac .et-fac__radio{position:absolute!important;opacity:0!important;width:1px!important;height:1px!important;min-height:0!important;margin:0!important;padding:0!important;border:0!important;pointer-events:none;}',
      '.et-fac__dot{position:relative;display:block;flex:0 0 16px;width:16px;height:16px;border:2px solid #b4b2a9;border-radius:50%;background:#fff;box-sizing:border-box;transition:border-color .2s;}',
      '.et-fac__opt.is-checked .et-fac__dot{border-color:#00B781;}',
      '.et-fac__opt.is-checked .et-fac__dot::after{content:"";position:absolute;top:50%;left:50%;width:8px;height:8px;margin:-4px 0 0 -4px;border-radius:50%;background:#00B781;}',
      '.et-fac__opt:has(.et-fac__radio:focus-visible){outline:2px solid #00B781;outline-offset:2px;}',
      '.et-fac__title{font-size:14px;font-weight:600;color:#0C3B33;line-height:1;}',
      '.et-fac__fields{display:none;margin-top:10px;padding:10px;border-radius:10px;background:#f5faf8;}',
      '.et-fac.is-open .et-fac__fields{display:block;}',
      '.et-fac__label{display:block;font-size:12px;font-weight:600;color:#0C3B33;margin:0 0 4px;}',
      '.et-fac__label--2{margin-top:8px;}',
      '.et-fac .et-fac__input{display:block;width:100%;height:38px;border:1px solid #e6e6e3;border-radius:10px;padding:0 12px;font-size:14px;background:#fff;color:#0C3B33;box-sizing:border-box;margin:0;}',
      '.et-fac .et-fac__input:focus{border-color:#00B781;outline:none;box-shadow:0 0 0 3px rgba(0,183,129,.15);}',
      '.et-fac .et-fac__input.is-error{border-color:#d93c3c;}',
      '.et-fac .et-fac__input--nif{text-transform:uppercase;}',
      '.et-fac__err{font-size:12px;line-height:1.35;color:#d93c3c;margin:4px 0 0;font-weight:500;}',
      '.et-fac__err[hidden]{display:none;}',
      '.et-fac__err--choice{margin:6px 0 0;}'
    ].join('');
    var tag = document.createElement('style');
    tag.id = 'et-fac-css';
    tag.appendChild(document.createTextNode(css));
    document.head.appendChild(tag);
  }

  function el(tag, cls, attrs, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) { for (var k in attrs) { if (attrs.hasOwnProperty(k)) e.setAttribute(k, attrs[k]); } }
    if (text) e.appendChild(document.createTextNode(text));
    return e;
  }

  function option(value, title) {
    var id = 'et-fac-' + value + '-' + uid;
    var lab = el('label', 'et-fac__opt' + (st.choice === value ? ' is-checked' : ''), { 'for': id, 'data-et-fac-opt': value });
    var r = el('input', 'et-fac__radio', { type: 'radio', id: id, name: 'et-fac-choice-' + uid, value: value, 'data-et-fac-radio': '' });
    r.checked = st.choice === value;
    lab.appendChild(r);
    lab.appendChild(el('span', 'et-fac__dot', { 'aria-hidden': 'true' }));
    lab.appendChild(el('span', 'et-fac__title', null, title));
    return lab;
  }

  function build(formId) {
    uid++;
    var b = el('div', 'et-fac' + (st.choice === 'si' ? ' is-open' : ''), {
      'data-et-fac': '',
      'data-form': formId,
      'role': 'radiogroup',
      'aria-labelledby': 'et-fac-q-' + uid,
      'data-edit': 'Bloque factura NIF/CIF (assets/et-factura-cif.js)'
    });

    var head = el('div', 'et-fac__head');
    head.appendChild(el('span', 'et-fac__q', { id: 'et-fac-q-' + uid }, '¿Necesitas factura? *'));
    var opts = el('div', 'et-fac__opts');
    opts.appendChild(option('si', 'Sí'));
    opts.appendChild(option('no', 'No'));
    head.appendChild(opts);
    b.appendChild(head);
    var e0 = el('p', 'et-fac__err et-fac__err--choice', { 'data-et-fac-err': 'choice', 'role': 'alert' });
    e0.hidden = true;
    b.appendChild(e0);

    var f = el('div', 'et-fac__fields');
    f.appendChild(el('label', 'et-fac__label', { 'for': 'et-fac-nif-' + uid }, 'NIF / CIF *'));
    var nif = el('input', 'et-fac__input et-fac__input--nif', {
      type: 'text', id: 'et-fac-nif-' + uid, 'data-et-fac-nif': '',
      placeholder: 'B12345678', autocomplete: 'off', maxlength: '14'
    });
    nif.value = st.nif;
    f.appendChild(nif);
    var e1 = el('p', 'et-fac__err', { 'data-et-fac-err': 'nif' });
    e1.hidden = true;
    f.appendChild(e1);
    f.appendChild(el('label', 'et-fac__label et-fac__label--2', { 'for': 'et-fac-rs-' + uid }, 'Razón social o nombre completo *'));
    var rs = el('input', 'et-fac__input', {
      type: 'text', id: 'et-fac-rs-' + uid, 'data-et-fac-rs': '',
      placeholder: 'Tu Empresa S.L.', autocomplete: 'organization', maxlength: '120'
    });
    rs.value = st.rs;
    f.appendChild(rs);
    var e2 = el('p', 'et-fac__err', { 'data-et-fac-err': 'rs' });
    e2.hidden = true;
    f.appendChild(e2);
    b.appendChild(f);

    b.appendChild(el('input', '', { type: 'hidden', form: formId, name: 'attributes[' + KEY_ON + ']', 'data-et-fac-h': 'on' }));
    b.appendChild(el('input', '', { type: 'hidden', form: formId, name: 'attributes[' + KEY_NIF + ']', 'data-et-fac-h': 'nif' }));
    b.appendChild(el('input', '', { type: 'hidden', form: formId, name: 'attributes[' + KEY_RS + ']', 'data-et-fac-h': 'rs' }));
    fillHidden(b);
    return b;
  }

  function onValue() {
    if (st.choice === 'si') return 'Sí';
    if (st.choice === 'no') return 'No';
    return '';
  }

  function fillHidden(b) {
    var yes = st.choice === 'si';
    b.querySelector('[data-et-fac-h=on]').value = onValue();
    b.querySelector('[data-et-fac-h=nif]').value = yes ? norm(st.nif) : '';
    b.querySelector('[data-et-fac-h=rs]').value = yes ? String(st.rs).trim() : '';
  }

  function paint(b) {
    b.classList.toggle('is-open', st.choice === 'si');
    var labs = b.querySelectorAll('[data-et-fac-opt]');
    for (var i = 0; i < labs.length; i++) {
      labs[i].classList.toggle('is-checked', labs[i].getAttribute('data-et-fac-opt') === st.choice);
    }
  }

  function formIdOf(btn) {
    return btn.getAttribute('form') || (btn.form && btn.form.id) || '';
  }

  function blockFor(formId) {
    var all = document.querySelectorAll('[data-et-fac]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('data-form') === formId) return all[i];
    }
    return null;
  }

  function inject() {
    var btns = document.querySelectorAll('button[name=checkout]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var formId = formIdOf(btn);
      if (!formId || blockFor(formId)) continue;
      var target = btn.closest('.hdt-mini-cart__view-checkout') || btn;
      if (target.parentNode) target.parentNode.insertBefore(build(formId), target);
    }
  }

  var saveTimer = null;
  function save() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      var yes = st.choice === 'si';
      var a = {};
      a[KEY_ON] = onValue();
      a[KEY_NIF] = yes ? norm(st.nif) : '';
      a[KEY_RS] = yes ? String(st.rs).trim() : '';
      fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: a })
      }).catch(function () {});
    }, 400);
  }

  function setChoiceErr(b, msg) {
    var p = b.querySelector('[data-et-fac-err=choice]');
    if (!p) return;
    if (msg) { p.textContent = msg; p.hidden = false; b.classList.add('is-error'); }
    else { p.textContent = ''; p.hidden = true; b.classList.remove('is-error'); }
  }

  function setErr(b, which, msg) {
    var p = b.querySelector('[data-et-fac-err=' + which + ']');
    var inp = b.querySelector(which === 'nif' ? '[data-et-fac-nif]' : '[data-et-fac-rs]');
    if (!p || !inp) return;
    if (msg) { p.textContent = msg; p.hidden = false; inp.classList.add('is-error'); }
    else { p.textContent = ''; p.hidden = true; inp.classList.remove('is-error'); }
  }

  function check(b) {
    if (!st.choice) {
      setChoiceErr(b, MSG_ELIGE);
      b.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var r = b.querySelector('[data-et-fac-radio]');
      if (r) r.focus({ preventScroll: true });
      return false;
    }
    setChoiceErr(b, '');
    if (st.choice !== 'si') return true;
    var ok = true;
    var first = null;
    var nifInp = b.querySelector('[data-et-fac-nif]');
    var rsInp = b.querySelector('[data-et-fac-rs]');
    var v = norm(nifInp.value);
    if (!v) { setErr(b, 'nif', MSG_NIF_VACIO); ok = false; first = nifInp; }
    else if (!valid(v)) { setErr(b, 'nif', MSG_NIF_MAL); ok = false; first = nifInp; }
    else { setErr(b, 'nif', ''); nifInp.value = v; st.nif = v; }
    if (!String(rsInp.value).trim()) { setErr(b, 'rs', MSG_RS_VACIO); ok = false; first = first || rsInp; }
    else { setErr(b, 'rs', ''); st.rs = rsInp.value; }
    fillHidden(b);
    if (first) first.focus();
    return ok;
  }

  function guard(e, btn) {
    var b = blockFor(formIdOf(btn));
    if (!b) return;
    if (!check(b)) { e.preventDefault(); e.stopImmediatePropagation(); }
    else { fillHidden(b); }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest('button[name=checkout]') : null;
    if (btn) guard(e, btn);
  }, true);

  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (s && s.name === 'checkout') guard(e, s);
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-et-fac]');
    if (!b) return;
    if (t.hasAttribute('data-et-fac-radio')) {
      st.choice = t.value;
      setChoiceErr(b, '');
      paint(b);
      if (st.choice === 'si') {
        var n = b.querySelector('[data-et-fac-nif]');
        if (n && !n.value) n.focus();
      } else {
        setErr(b, 'nif', '');
        setErr(b, 'rs', '');
      }
    }
    if (t.hasAttribute('data-et-fac-nif')) {
      var v = norm(t.value);
      t.value = v;
      st.nif = v;
      setErr(b, 'nif', v && !valid(v) ? MSG_NIF_MAL : '');
    }
    if (t.hasAttribute('data-et-fac-rs')) st.rs = t.value;
    fillHidden(b);
    save();
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-et-fac]');
    if (!b) return;
    if (t.hasAttribute('data-et-fac-nif')) { st.nif = t.value; setErr(b, 'nif', ''); }
    if (t.hasAttribute('data-et-fac-rs')) { st.rs = t.value; setErr(b, 'rs', ''); }
    fillHidden(b);
  });

  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key === 'Enter' && t && t.closest && t.closest('[data-et-fac]') && t.tagName === 'INPUT') e.preventDefault();
  });

  var pending = false;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; inject(); });
  });

  function start() {
    fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var a = (c && c.attributes) || {};
        st.choice = a[KEY_ON] === 'Sí' ? 'si' : (a[KEY_ON] === 'No' ? 'no' : '');
        st.nif = a[KEY_NIF] || '';
        st.rs = a[KEY_RS] || '';
      })
      .catch(function () {})
      .then(function () {
        addCss();
        inject();
        mo.observe(document.body, { childList: true, subtree: true });
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();